

export default {
    name: 'MenuCmsPage',

    computed: {
        path() {
            return this.$route.path === '/' ? 'homepage' : this.$route.path;
        },
    },

};
